import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'HTML2TXT',
    standalone: true
})
export class HTML2TXTPipe implements PipeTransform {
    transform(msg: any): any {
        // #1039 - dash key in question Key
        return (msg + '').replace(/\<|\>|\"|\#|\-|\'|\&/g,
            function (MatchStr) {
                switch (MatchStr) {
                    case "#":
                        return "hash";
                    case "-":
                        return "dash";
                    case "&":
                        return "and";
                    default:
                        return '';
                }
            }
        )
    }
}

@Pipe({
    name: 'ByQuestionKey',
    standalone: true
})
export class ByQuestionKeyPipe implements PipeTransform {
    transform(q: any, k: any): any {
        return q.filter((x: any) => {
            let pipe = new HTML2TXTPipe();
            let tempQuestionKey = pipe.transform(x.questionKey.toLowerCase());
            return tempQuestionKey === k;
        })
    }
}

/*
 *  //This Filter is used to replace _(underScore) with space
 */
@Pipe({
    name: 'hypenLess',
    standalone: true
})
export class HypenLessPipe implements PipeTransform {
    transform(word: any, args?: any): any {
        return word.replace(/_/g, ' ');
    }
}

@Pipe({
    name: 'orderBy',
    standalone: true
})
export class OrderByPipe implements PipeTransform {
    transform(array: any, orderBy: string, asc = true): any {
        if (orderBy.includes('-')) {
            asc = false;
            orderBy = orderBy.replace('-', '');
        }
        if (!orderBy || orderBy.trim() == '') {
            return array;
        }

        let tempArr = orderBy.split('.'); // for sort nested field like as accounting.invoice

        //Case - ascending
        if (asc) {
            return Array.from(array).sort((item1: any, item2: any) => {
                if (tempArr.length > 1) { // if nested sorting field
                    if (tempArr.length === 2) { // here handled nested upto 2 like as accounting.invoice
                        return this.orderByComparator(item1[tempArr[0]][tempArr[1]] || 0, item2[tempArr[0]][tempArr[1]] || 0);
                    } else if (tempArr.length === 3) { // here handled nested upto 3 like as accounting.invoice
                        return this.orderByComparator(item1[tempArr[0]][tempArr[1]][tempArr[2]] || 0, item2[tempArr[0]][tempArr[1]][tempArr[2]] || 0);
                    } else { // for regular/single field sorting meands field is not nested
                        return this.orderByComparator(item1[orderBy] || 0, item2[orderBy] || 0);
                    }
                } else { // for regular/single field sorting meands field is not nested
                    return this.orderByComparator(item1[orderBy] || 0, item2[orderBy] || 0);
                }
            });
        } else {
            //Case - descending
            return Array.from(array).sort((item1: any, item2: any) => {
                if (tempArr.length > 1) { // if nested sorting field
                    if (tempArr.length === 2) { // here handled nested upto 2 like as accounting.invoice
                        return this.orderByComparator(item2[tempArr[0]][tempArr[1]], item1[tempArr[0]][tempArr[1]]);
                    } else if (tempArr.length === 3) { // here handled nested upto 3 like as accounting.invoice
                        return this.orderByComparator(item2[tempArr[0]][tempArr[1]][tempArr[2]], item1[tempArr[0]][tempArr[1]][tempArr[2]]);
                    } else {
                        return this.orderByComparator(item2[orderBy], item1[orderBy]);
                    }
                } else {
                    return this.orderByComparator(item2[orderBy], item1[orderBy]);
                }

            });
        }
    }

    orderByComparator(a: any, b: any): number {
        // If a or b is undefined
        if ((!a && a !== 0) || (!b && b !== 0)) {
            return 0;
        }
        //Case of string sort
        if ((Number.isNaN(Number.parseFloat(a)) || !Number.isFinite(a)) || (Number.isNaN(Number.parseFloat(b)) || !Number.isFinite(b))) {
            if (a.toString().toLowerCase() < b.toString().toLowerCase()) {
                return -1;
            }
            if (a.toString().toLowerCase() > b.toString().toLowerCase()) {
                return 1;
            }
        } else {
            // Case of number sort
            if (Number.parseFloat(a) < Number.parseFloat(b)) {
                return -1;
            }
            if (Number.parseFloat(a) > Number.parseFloat(b)) {
                return 1;
            }
        }
        return 0; // a, b are equal to each other
    }
} 
